import React, { useState } from "react";
import SideBar from "../navigation/sidebar/SideBar";
import NavBar from "../navigation/topnav/NavBar";
import { MdAdd } from "react-icons/md";
import CalendarComp from "../components/CalendarComp";
import RowTitles from "../components/RowTitles";

const Calendar = () => {
  return (
    <div className="d-flex" style={{ backgroundColor: "#f1f5f7" }}>
      <SideBar />
      {/* Main Content */}
      <div className="flex-grow-1">
        {/* Header */}
        <NavBar />
        <div className="container-fluid mt-4">
          <RowTitles title={"Dashboad"} child={"Calendar"} />
          <div className="row">
            <div className="col-md-6">
              <h4 className="mb-3 mt-2">Calendar</h4>
            </div>
            <div className="col-md-6 text-end">
              <button
                className="btn  text-black me-2 mt-2 mb-3"
                style={{ borderRadius: 0, backgroundColor: "#3bc0c3" }}
              >
                <MdAdd className="me-2" />
                New event
              </button>
            </div>
          </div>
          <div className="bg-white shadow p-3" style={{ borderRadius: 10 }}>
            <CalendarComp />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Calendar;
